import { useEffect, useState } from "react";
import { FaDownload, FaTrash, FaFile } from "react-icons/fa";
import { useGetRequestQuery } from "../../../../Hooks/useGetRequestQuery";
import { useMutationRequestQuery } from "../../../../Hooks/useMutationRequestQuery"; 
import { getLeadDocumentsService, deleteLeadDocumentService } from "../../../../Services/CRMAdminServices/CRMTaskListService";
import DataTable from "react-data-table-component";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { toast } from "react-toastify";

const DocumentList = ({ leadID }: any) => {
    const [documents, setDocuments] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedDocumentId, setSelectedDocumentId] = useState<number | null>(null);

    // Fetch documents
    const { data: documentsData, isLoading, isError , refetch} = useGetRequestQuery<any>(
        ['getCRMLeadDocuments', leadID],
        () => getLeadDocumentsService(leadID),
        { enabled: !!leadID }
    );

    useEffect(() => {
        if (documentsData && !isError && !isLoading) {
            setDocuments(documentsData?.data);
            console.log("documentData:-",documentsData?.data)
        }
    }, [documentsData, isError, isLoading]);

    // Mutation for deleting a document
    const { mutate: deleteDocument, isPending: isDeleting } = useMutationRequestQuery(
        "deleteLeadDocument",
        deleteLeadDocumentService,
        {
            onSuccess: () => {
                toast.success("Document deleted successfully.");
                setDeleteModal(false);
                refetch()
            },
            onError: () => {
                toast.error("Failed to delete document.");
                setDeleteModal(false);
            },
        }
    );

    const confirmDelete = (id: number) => {
        setSelectedDocumentId(id);
        setDeleteModal(true);
    };

    const handleDeleteClick = () => {
        if (selectedDocumentId) {
            deleteDocument(selectedDocumentId);
        }
    };

    const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/`;

    const documentColumns = [
        {
            name: "Action",
            cell: (row: any) => (
                <ul className="action simple-list flex-row">
                    <li className="download" style={{ cursor: "pointer" }}>
                        <a
                            href={`${BASE_URL}${row.documentPath}`}
                            download
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaDownload />
                        </a>
                    </li>
                    <li className="delete" style={{ marginLeft: "10px" }}>
                        <a onClick={() => confirmDelete(row.id)} href="#">
                            <FaTrash />
                        </a>
                    </li>
                </ul>
            ),
            width: "8rem",
        },
        {
            name: "File",
            cell: (row: any) => (
                <span className="file-item">
                    <FaFile /> {row.documentName}
                </span>
            ),
            width: "80rem",
        },
    ];

    return (
        <div>
            <h3 className="heading-color f-w-900">Documents</h3>
            {!isLoading && !isError && (
                <DataTable
                    columns={documentColumns}
                    data={documents}
                    // pagination
                />
            )}

            {/* Delete Confirmation Modal */}
            <Modal isOpen={deleteModal} toggle={() => setDeleteModal(!deleteModal)} centered>
                <ModalHeader toggle={() => setDeleteModal(!deleteModal)}>Confirm Delete</ModalHeader>
                <ModalBody>Are you sure you want to delete this document?</ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => setDeleteModal(false)}>Cancel</Button>
                    <Button color="danger" onClick={handleDeleteClick} disabled={isDeleting}>
                        {isDeleting ? "Deleting..." : "Delete"}
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default DocumentList;
